<div class="card">
    <div class="processes-head">
        <div class="float-left">
            {{ process.name }}
        </div>
        <div class="float-right idProcesses">
            ID: {{ process.id }}
        </div>
    </div>
    <div class="card-body status-process" (click)="$event.stopPropagation()">
        <div class="row processes-body">
            <div class="col-4">
                <div>
                    <span class="caption">
                        Type:
                    </span>
                    <span>
                        {{ getProcessSelectionTypes() }}
                    </span>
                </div>
                <div>
                    <span class="caption">
                        Start date:
                    </span>
                    <span>
                        {{ process.startDate | date: 'MMMM dd, yyyy' }}
                    </span>
                </div>
                <div>
                    <span class="caption">
                        Survey name:
                    </span>
                    <span>
                        {{ process.surveyName }}
                    </span>
                </div>
                <!-- Do not remove. Will be implemented -->
                <!--<div>
                    <span class="caption">
                        Repeat process:
                    </span>
                    <span class="repeat-process">
                        Yes
                    </span>
                </div>-->
            </div>
            <div class="col-8 pl-0">
                <div class="caption">
                    Appraisees:
                </div>
                <div>
                    <div class="font-weight-bold">
                        <span *ngFor="let bu of process.appraisedBusinessUnits; let i = index">
                            {{ bu.name }}
                            <i *ngIf="i+1 !== process.appraisedBusinessUnits.length"> , </i>
                        </span>
                    </div>
                    <div class="estimated">
                        <div [collapse]="!isCollapsed" id="process-list-persons" [class.list-evaluated-on]="isCollapsed" [class.list-evaluated-off]="!isCollapsed">
                            <span *ngFor="let p of process.appraisedPersons; let i = index">
                                {{ p.isActive ? p.name : p.gpid }}
                                <i *ngIf="i+1 !== process.appraisedPersons.length"> ; </i>
                            </span>
                        </div>
                        <span (click)="$event.stopPropagation()" class="arrow" *ngIf="showCollapse()">
                            <i (click)="isCollapsed = !isCollapsed" class="fa"
                               [class.fa-chevron-down]="isCollapsed"
                               [class.fa-chevron-up]="!isCollapsed"></i>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="process-state" [ngClass]="{
             'state-completed': process.stage == processStage.Completed,
             'state-active': process.stage == processStage.Active,
             'state-drafts': process.stage == processStage.Draft,
             'state-cancelled': process.stage == processStage.Cancelled,
             'state-pending': process.stage == processStage.Pending}">
    </div>
</div>
